import './Navbar.css';
import { useEffect, useState, useRef, useCallback, useMemo } from 'react';
import { FaTimes, FaBars } from 'react-icons/fa';
import { FaUserCircle, FaSignOutAlt, FaChevronDown, FaClipboardList, FaHeart } from 'react-icons/fa';
import { FiUser } from 'react-icons/fi';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import Marquee from "react-fast-marquee";
import * as THREE from 'three';
import gsap from 'gsap';
import { fetchCategories } from '../../redux/actions/CategoriesAction';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useDarkMode } from '../../App';

import { fetchFooterSocialLinks } from '../../redux/actions/FooterSocialLinksAction';
import { logout } from '../../redux/slices/loginSlice';
import { removeCart } from '../../redux/actions/cartAction';
import { clearCart } from '../../redux/slices/cartSlice';
import { clearFavorites } from '../../redux/slices/favoriteSlice';
import { fetchSliderTexts } from '../../redux/actions/sliderTextsActions';
import { fetchSocialLinks } from '../../redux/actions/socialLinksActions';
import { fetchFavorites } from '../../redux/actions/favoriteAction';
import FixedCartIcon from '../FixedCartIcon/FixedCartIcon';
import SuccessMessage from '../SuccessMessage/SuccessMessage';


function Navbar() {
    const { categories, isLoading, error } = useSelector((state) => state.categories);
    const { data: socialLinks, isLoading: socialLinksLoading } = useSelector((state) => state.socialLinks);
    const { items: favoriteItems } = useSelector((state) => state.favorite);
    const loginState = useSelector(state => state.login);
    const { isAuthenticated } = loginState || {};
    const { i18n } = useTranslation("global")
    const dispatch = useDispatch()
    const favoritesCount = favoriteItems?.length || 0;

    useEffect(() => {
        dispatch(fetchCategories(i18n.language));
        dispatch(fetchSliderTexts(i18n.language));
        dispatch(fetchSocialLinks(i18n.language));
        // Fetch favorites if user is authenticated
        const token = localStorage.getItem("token") || JSON.parse(localStorage.getItem("userTools") || "{}")?.token;
        if (token && token !== 'social_login_placeholder') {
            dispatch(fetchFavorites({ language: i18n.language }));
        }
    }, [dispatch, i18n.language, isAuthenticated]);

    // تغيير اتجاه الصفحة حسب اللغة
    useEffect(() => {
        document.documentElement.dir = i18n.language === 'ar' ? 'rtl' : 'ltr';
        // //console.log(i18n.language);
        localStorage.setItem('lang', i18n.language);
    }, [i18n.language]);

    return (
        <>
            <TopNav categories={categories} isLoading={isLoading} error={error} />
            <MainNav categories={categories} isLoading={isLoading} error={error} favoritesCount={favoritesCount} />
            <FixedCartIcon />
            <SuccessMessage />
        </>
    );
}

function TopNav({ categories, isLoading, error }) {
    const canvasRef = useRef();
    const { isDarkMode } = useDarkMode();
    const dispatch = useDispatch();
    // جلب نصوص السلايدر من API
    const { data: sliderTexts, isLoading: sliderTextsLoading, error: sliderTextsError } = useSelector(state => state.sliderTexts);
    
   
    
    // استخدام البيانات من API أو النصوص الاحتياطية
    const displayTexts = sliderTexts && sliderTexts.length > 0 
        ? sliderTexts.map(item => item.text)
        : [];
    
    // جلب روابط السوشيال من API الجديد
    const { data: socialLinks, isLoading: socialLinksLoading } = useSelector(state => state.socialLinks);
    // Helper to get url by platform
    const getSocialUrl = (platform) => socialLinks?.find(link => link.platform === platform)?.url;
    useEffect(() => {
        // إعداد مشهد النجوم
        const scene = new THREE.Scene();
        const camera = new THREE.PerspectiveCamera(75, window.innerWidth / 60, 0.1, 1000);
        camera.position.z = 80;
        const renderer = new THREE.WebGLRenderer({ alpha: true });
        renderer.setSize(window.innerWidth, 60);
        renderer.setClearColor(0x000000, 0);
        if (canvasRef.current) {
            canvasRef.current.appendChild(renderer.domElement);
        }
        // نجوم
        const starsGeometry = new THREE.BufferGeometry();
        const starCount = 60;
        const positions = [];
        for (let i = 0; i < starCount; i++) {
            positions.push(
                (Math.random() - 0.5) * window.innerWidth,
                (Math.random() - 0.5) * 60,
                Math.random() * -200
            );
        }
        starsGeometry.setAttribute('position', new THREE.Float32BufferAttribute(positions, 3));
        const starsMaterial = new THREE.PointsMaterial({ color: 0xff8800, size: 1.5 });
        const stars = new THREE.Points(starsGeometry, starsMaterial);
        scene.add(stars);
        gsap.to(stars.rotation, { y: Math.PI * 2, duration: 18, repeat: -1, ease: 'linear' });
        let running = true;
        function animate() {
            if (!running) return;
            renderer.render(scene, camera);
            requestAnimationFrame(animate);
        }
        animate();
        return () => {
            running = false;
            renderer.dispose();
            const canvasElement = canvasRef.current;
            if (canvasElement) {
                canvasElement.innerHTML = '';
            }
        };
    }, []);
    const { t } = useTranslation("global");
    return (
        <section className={`top-nav ${isDarkMode ? 'dark-mode' : ''}`} style={{ overflow: 'hidden' }}>
            <div ref={canvasRef} style={{ position: 'absolute', inset: 0, width: '100%', height: 60, zIndex: 0, pointerEvents: 'none' }} />
            <div className="container flex-wrap mt-2" style={{ position: 'relative', zIndex: 1 }}>
                <div className="scrolling-wrapper text-center mx-auto">
                    <img src="/Icon.png" alt="before" className="before-icon" />
                    <div className="scrolling-text mb-2" style={{ whiteSpace: "wrap" }}>
                        {sliderTextsLoading ? (
                            <div style={{ color: '#FFD700', textAlign: 'center' }}>
                                {t('navbar.loading', 'جاري التحميل...')}
                            </div>
                        ) : sliderTextsError ? (
                            <div style={{ color: '#ff6b6b', textAlign: 'center' }}>
                                {t('navbar.loadingError', 'خطأ في تحميل النصوص')}
                            </div>
                        ) : (
                            <Marquee speed={90} delay={0}>
                                {displayTexts.map((text, idx) => (
                                    <span key={idx} style={{ margin: '0 32px', display: 'inline-block' }}>
                                        {text}
                                        {idx !== displayTexts.length - 1 && <span style={{ margin: '0 16px', color: '#FFD700', fontWeight: 'bold' }}>|</span>}
                                    </span>
                                ))}
                            </Marquee>
                        )}
                    </div>
                    <img src="/Icon.png" alt="after" className="after-icon" />
                </div>
                <div className="left-icons mx-auto mb-2">
                    {socialLinksLoading ? (
                        <div className="text-center">
                            <div className="spinner-border spinner-border-sm text-white" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : (
                        socialLinks && socialLinks.length > 0 ? (
                            socialLinks.map((link, index) => {
                                const getIconClass = (platform) => {
                                    switch(platform) {
                                        case 'instagram': return 'fab fa-instagram';
                                        case 'twitter': return 'fab fa-x-twitter';
                                        case 'linkedin': return 'fab fa-linkedin';
                                        case 'youtube': return 'fab fa-youtube';
                                        case 'facebook': return 'fab fa-facebook';
                                        case 'behance': return 'fab fa-behance';
                                        default: return 'fab fa-link';
                                    }
                                };
                                
                                return (
                                    <a 
                                        key={index}
                                        href={link.url} 
                                        target="_blank" 
                                        rel="noopener noreferrer"
                                        className="text-white"
                                        style={{fontSize: 'clamp(16px, 4vw, 22px)', marginRight: 12, marginTop: 6}}
                                    >
                                        <i className={getIconClass(link.platform)}></i>
                                    </a>
                                );
                            })
                        ) : (
                            <div className="text-white small">لا توجد روابط متاحة</div>
                        )
                    )}
                </div>
            </div>
        </section>
    );
}

function MainNav({ categories, isLoading, error, favoritesCount = 0 }) {
    const [menuOpen, setMenuOpen] = useState(false);
    const [userMenuOpen, setUserMenuOpen] = useState(false);
    const [isFixed, setIsFixed] = useState(false);
    const { t, i18n } = useTranslation("global")
    const [mobileSearch, setMobileSearch] = useState(""); // للموبايل
    const navigate = useNavigate();
    const { isDarkMode, toggleDarkMode } = useDarkMode();
    const loginState = useSelector(state => state.login);
    const { isAuthenticated, user } = loginState || {};
    const userMenuRef = useRef(null);
    const dispatch = useDispatch();
    const handleLogout = () => {
        dispatch(logout());
        // dispatch(removeCart(i18n.language)); // Don't delete from server on logout
        dispatch(clearCart()); // Clear local state
        dispatch(clearFavorites());
        setUserMenuOpen(false);
        navigate('/');
    };

    // إغلاق قائمة المستخدم عند الضغط خارجها
    useEffect(() => {
        function onDocClick(e) {
            if (userMenuRef.current && !userMenuRef.current.contains(e.target)) {
                setUserMenuOpen(false);
            }
        }
        document.addEventListener('mousedown', onDocClick);
        return () => document.removeEventListener('mousedown', onDocClick);
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 60) {
                setIsFixed(true);
            } else {
                setIsFixed(false);
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // زر تغيير اللغة
    const toggleLang = () => {
        const newLang = i18n.language === 'ar' ? 'en' : 'ar';
        i18n.changeLanguage(newLang);
        localStorage.setItem('lang', newLang);
        document.documentElement.dir = newLang === 'ar' ? 'rtl' : 'ltr';
        // إغلاق الـ sidenav عند تغيير اللغة
        setMenuOpen(false);
    };

    // Memoized function لإغلاق الـ sidenav عند الضغط على رابط
    const handleLinkClick = useCallback(() => {
        setMenuOpen(false);
    }, []);




    // تحديد اتجاه السايدبار بناءً على اللغة
    const isLTR = i18n.language === 'en';
    return (
        <nav className={`main-nav${isFixed ? ' navbar-fixed' : ''} ${isDarkMode ? 'dark-mode' : ''}`}>
            <div className="container">
                <div className="mobile-menu-icon" onClick={() => setMenuOpen(true)}>
                    <FaBars />
                </div>
                <div className="logo mb-0">
                    <Link to="/" className="d-flex align-items-center">
                        <img src='/ToolsWorldLogo.jfif' alt="One Plus Logo" style={{ width: "clamp(30px, 8vw, 50px)", borderRadius: "10px" }} />

                    </Link>
                </div>

                <button
                    className="theme-toggle-btn"
                    onClick={toggleDarkMode}
                    aria-label={isDarkMode ? 'تفعيل الوضع النهاري' : 'تفعيل الوضع الليلي'}
                    style={{
                        margin: '0  0.5rem  ',
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        fontSize: 'clamp(1rem, 3vw, 1.5rem)',
                        transition: 'all 0.3s ease',
                        color: isDarkMode ? '#ffd700' : '#000c3d',
                        padding: '8px',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: 'clamp(28px, 6vw, 40px)',
                        height: 'clamp(28px, 6vw, 40px)',
                        backgroundColor: isDarkMode ? 'rgba(255, 215, 0, 0.1)' : 'rgba(0, 12, 61, 0.1)'
                    }}
                >
                    {isDarkMode ? '☀️' : '🌙'}
                </button>

                {/* Mobile User Icon */}
                <div className="mobile-user-icon">
                    {isAuthenticated ? (
                        <Link to="/profile" className="mobile-nav-link" aria-label="Profile">
                            {user?.name ? (
                                <div className="mobile-avatar">
                                    {user.name.charAt(0).toUpperCase()}
                                </div>
                            ) : (
                                <FaUserCircle />
                            )}
                        </Link>
                    ) : (
                        <Link to="/login" className="mobile-nav-link" aria-label="Login">
                            <FiUser />
                        </Link>
                    )}
                </div>


                <ul className="nav-links mt-3 text-center mx-auto justify-content-center">
                    <li><NavLink to="/" className={({ isActive }) => isActive ? "active" : ""} style={{ color: isDarkMode ? 'var(--color-text)' : undefined }}>{t('navbar.home')}</NavLink></li>
                    <li><NavLink to="/categories" className={({ isActive }) => isActive ? "active" : ""} style={{ color: isDarkMode ? 'var(--color-text)' : undefined }}>{t('navbar.categories')}</NavLink></li>
                    <li><NavLink to="/offers" className={({ isActive }) => isActive ? "active" : ""} style={{ color: isDarkMode ? 'var(--color-text)' : undefined }}>{t('navbar.offers')}</NavLink></li>
                    <li><NavLink to="/contact" className={({ isActive }) => isActive ? "active" : ""} style={{ color: isDarkMode ? 'var(--color-text)' : undefined }}>{t('navbar.contact')}</NavLink></li>
                </ul>


                <div className="search-lang hidden">

               

                    <Link to={'/cart'} style={{ position: 'relative', display: 'inline-block' }}>
                        <svg width="28" height="28" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10 10V8.75C10 7.42392 10.5268 6.15215 11.4645 5.21447C12.4021 4.27678 13.6739 3.75 15 3.75C16.3261 3.75 17.5979 4.27678 18.5355 5.21447C19.4732 6.15215 20 7.42392 20 8.75V10M18.75 17.5V15M11.25 17.5V15" stroke={isDarkMode ? 'var(--color-text)' : '#000c3d'} strokeWidth="2" strokeLinecap="round" />
                            <path d="M5 15C5 12.6425 5 11.465 5.7325 10.7325C6.465 10 7.6425 10 10 10H20C22.3575 10 23.535 10 24.2675 10.7325C25 11.465 25 12.6425 25 15V16.25C25 20.9637 25 23.3212 23.535 24.785C22.07 26.2487 19.7137 26.25 15 26.25C10.2863 26.25 7.92875 26.25 6.465 24.785C5.00125 23.32 5 20.9637 5 16.25V15Z" stroke={isDarkMode ? 'var(--color-text)' : '#000c3d'} strokeWidth="2" />
                        </svg>
                    </Link>

                    <span className="lang" style={{ cursor: 'pointer', marginLeft: 12, color: isDarkMode ? 'var(--color-text)' : undefined }} onClick={toggleLang}>
                        {i18n.language === 'ar' ? 'EN' : 'AR'}
                    </span>

                    <Link to="/favorites" title={t('favorites.title')} className="order-icon-link heart" style={{ position: 'relative' }}>
                        <FaHeart />
                        {favoritesCount > 0 && (
                            <span style={{
                                position: 'absolute',
                                top: '-8px',
                                right: '-8px',
                                background: '#ff3e3e',
                                color: 'white',
                                borderRadius: '50%',
                                width: '18px',
                                height: '18px',
                                fontSize: '11px',
                                fontWeight: 'bold',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                boxShadow: '0 2px 5px rgba(255,62,62,0.4)'
                            }}>
                                {favoritesCount > 99 ? '99+' : favoritesCount}
                            </span>
                        )}
                    </Link>

                    <Link to="/orders" title={t('navbar.orders')} className="order-icon-link">
                        <FaClipboardList />
                    </Link>

                      
                    {/* User area: login icon or profile dropdown */}
                    <div className="user-area" ref={userMenuRef}>
                        {isAuthenticated ? (
                            <div className={`dropdown-nav ${userMenuOpen ? 'open' : ''}`}>
                                <button className="dropdown-toggle-nav" onClick={() => setUserMenuOpen(s => !s)} aria-expanded={userMenuOpen}>
                                    <div className="avatar">
                                        {user?.name ? user.name.charAt(0).toUpperCase() : <FaUserCircle />}
                                    </div>
                                    <span className="username">{user?.name || user?.email || 'User'}</span>
                                    <FaChevronDown className="dropdown-arrow" />
                                </button>
                                {userMenuOpen && (
                                    <div className="dropdown-menu-nav">
                                        <div className="dropdown-header">
                                            <div className="header-avatar">
                                                {user?.name ? user.name.charAt(0).toUpperCase() : <FaUserCircle />}
                                            </div>
                                            <div className="header-info">
                                                <span className="header-name">{user?.name || 'User'}</span>
                                                <span className="header-email">{user?.email}</span>
                                            </div>
                                        </div>
                                        <div className="dropdown-divider"></div>
                                        <ul className="dropdown-list">
                                            <li className="dropdown-item-nav">
                                                <Link to="/profile" onClick={() => setUserMenuOpen(false)}>
                                                    <div className="icon-box"><FiUser /></div>
                                                    <span>{t('navbar.profile', 'Profile')}</span>
                                                </Link>
                                            </li>
                                            <li className="dropdown-item-nav">
                                                <button className="logout-btn" onClick={handleLogout}>
                                                    <div className="icon-box"><FaSignOutAlt /></div>
                                                    <span>{t('navbar.logout', 'Logout')}</span>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                )}
                            </div>
// ... (imports will be handled by replacing the specific block)

                        ) : (
                            <Link to="/login" className="order-icon-link" aria-label="تسجيل الدخول" title={t('navbar.login','Login') }>
                                <FiUser />
                            </Link>
                        )}
                    </div>
                    
                </div>



            </div>


            {/* Backdrop */}
            <div 
                className={`mobile-menu-backdrop ${menuOpen ? 'open' : ''}`}
                onClick={() => setMenuOpen(false)}
            />
            
            <div
                className={`mobile-menu ${menuOpen ? 'open' : ''} ${isDarkMode ? 'dark-mode' : ''}`}
                style={isLTR ? { left: menuOpen ? 0 : '-100%', right: 'auto' } : { right: menuOpen ? 0 : '-100%', left: 'auto' }}
            >
                <div className="close-btn" onClick={() => setMenuOpen(false)}>
                    <FaTimes />
                </div>
                <ul className="nav">
                    <li className="nav-item mb-3">
                        <NavLink
                            to="/"
                            onClick={handleLinkClick}
                            className={({ isActive }) =>
                                ` fw-bold text-decoration-none ${isActive ? "active text-primary" : ""}`}
                            style={{ color: isDarkMode ? 'var(--color-text)' : 'black' }}
                        >
                            {t('navbar.home')}
                        </NavLink>
                    </li>
                    <li className="nav-item  mb-3 p-0">
                        <NavLink
                            to="/categories"
                            onClick={handleLinkClick}
                            className={({ isActive }) => (isActive ? "active nav-link  fw-bold text-decoration-none p-0" : "nav-link p-0  fw-bold text-decoration-none")}
                            id="mobileCategoriesDropdown"
                            role="button"
                            // data-bs-toggle="dropdown"
                            aria-expanded="false"
                            style={{ color: isDarkMode ? 'var(--color-text)' : 'black' }}
                        >
                            {t('navbar.categories')}
                        </NavLink>
                        
                    </li>

                    <li className="nav-item mb-3">
                        <NavLink
                            to="/offers"
                            onClick={handleLinkClick}
                            className={({ isActive }) =>
                                ` fw-bold text-decoration-none ${isActive ? "active text-primary" : ""}`}
                            style={{ color: isDarkMode ? 'var(--color-text)' : 'black' }}
                        >
                            {t('navbar.offers')}
                        </NavLink>
                    </li>
                    <li className="nav-item mb-3">
                        <NavLink
                            to="/contact"
                            onClick={handleLinkClick}
                            className={({ isActive }) =>
                                `mb-2 fw-bold text-decoration-none ${isActive ? "active text-primary" : ""}`}
                            style={{ color: isDarkMode ? 'var(--color-text)' : 'black' }}
                        >
                            {t('navbar.contact')}
                        </NavLink>
                    </li>
                </ul>

                <div className="mobile-extra-icons d-flex align-items-center gap-3 mb-3">
                    <span className="lang" style={{ cursor: 'pointer', color: isDarkMode ? 'var(--color-text)' : undefined }} onClick={toggleLang}>
                        {i18n.language === 'ar' ? 'EN' : 'AR'}
                    </span>

                    <Link to="/favorites" onClick={handleLinkClick} title={t('favorites.title')} className="order-icon-link mobile heart" style={{ position: 'relative' }}>
                        <FaHeart />
                        {favoritesCount > 0 && (
                            <span style={{
                                position: 'absolute',
                                top: '-8px',
                                right: '-8px',
                                background: '#ff3e3e',
                                color: 'white',
                                borderRadius: '50%',
                                width: '18px',
                                height: '18px',
                                fontSize: '11px',
                                fontWeight: 'bold',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                boxShadow: '0 2px 5px rgba(255,62,62,0.4)'
                            }}>
                                {favoritesCount > 99 ? '99+' : favoritesCount}
                            </span>
                        )}
                    </Link>

                    <Link to="/orders" onClick={handleLinkClick} title={t('navbar.orders')} className="order-icon-link mobile">
                        <FaClipboardList />
                    </Link>
                        {/* Show login icon in mobile menu if not authenticated */}
                        {!isAuthenticated && (
                            <Link to="/login" onClick={handleLinkClick} className="order-icon-link mobile" aria-label="تسجيل الدخول" title={t('navbar.login','Login') }>
                                <FiUser />
                            </Link>
                        )}
                </div>

                <Link to={'/cart'} onClick={handleLinkClick} style={{ position: 'relative', display: 'inline-block' }}>
                    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 10V8.75C10 7.42392 10.5268 6.15215 11.4645 5.21447C12.4021 4.27678 13.6739 3.75 15 3.75C16.3261 3.75 17.5979 4.27678 18.5355 5.21447C19.4732 6.15215 20 7.42392 20 8.75V10M18.75 17.5V15M11.25 17.5V15" stroke={isDarkMode ? 'var(--color-text)' : '#000c3d'} strokeWidth="2" strokeLinecap="round" />
                        <path d="M5 15C5 12.6425 5 11.465 5.7325 10.7325C6.465 10 7.6425 10 10 10H20C22.3575 10 23.535 10 24.2675 10.7325C25 11.465 25 12.6425 25 15V16.25C25 20.9637 25 23.3212 23.535 24.785C22.07 26.2487 19.7137 26.25 15 26.25C10.2863 26.25 7.92875 26.25 6.465 24.785C5.00125 23.32 5 20.9637 5 16.25V15Z" stroke={isDarkMode ? 'var(--color-text)' : '#000c3d'} strokeWidth="2" />
                    </svg>
                </Link>

                

             
            </div>
        </nav>
        
       
    );
}

export default Navbar;
